import Modal from '../../../../components/Modal/Modal';
import { Button, ButtonVariation } from '../../../../components/Button';
import { ModalSize } from '../../../../utils';

import './SaveAndExitModal.css';

export interface SaveAndExitModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSaveAndExit: () => void;
  'data-testid'?: string;
}

function SaveAndExitModal({ isOpen, onClose, onSaveAndExit, 'data-testid': dataTestId }: SaveAndExitModalProps) {
  const baseTestId = dataTestId ?? 'save-exit-modal';

  const handleSaveAndExit = () => {
    onSaveAndExit();
    onClose();
  };

  return (
    <Modal
      className='save-exit-modal-wrapper'
      data-testid={baseTestId}
      heading='Save and exit?'
      isOpen={isOpen}
      size={ModalSize.Medium}
      onClose={onClose}>
      <div
        className='save-exit-modal'
        data-testid={`${baseTestId}-content`}>
        <p
          className='save-exit-modal__description'
          data-testid={`${baseTestId}-description`}>
          Your progress will be saved. You can return later to continue your application.
        </p>
        <div
          className='save-exit-modal__actions'
          data-testid={`${baseTestId}-actions`}>
          <Button
            bordered
            isAutoWidth
            aria-label='Continue application - stay on current step'
            data-testid={`${baseTestId}-continue`}
            type='button'
            variation={ButtonVariation.GHOST}
            onClick={onClose}>
            Continue application
          </Button>
          <Button
            isAutoWidth
            aria-label='Save and exit - return to application home'
            data-testid={`${baseTestId}-confirm`}
            type='button'
            variation={ButtonVariation.SOLID}
            onClick={handleSaveAndExit}>
            Save and exit
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default SaveAndExitModal;
